import React from 'react';
import ReactDOM from 'react-dom';
import 'url-search-params-polyfill';
import './index.css';
import App from './app';
import reportWebVitals from './reportWebVitals';
import ThemeProvider, {theme} from "./common/components/base/theme";
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
